import React, { useEffect, useState } from 'react';
import Navbar from '../NavbarFooter/Navbar';
import './home.css';
import { Link, useNavigate } from "react-router-dom";
import Footer from '../NavbarFooter/Footer';
import styles from '../CategoryPage/category.module.css';
import Card from '../CategoryPage/Card.jsx';
import axios from 'axios';
import categoryBG from '../../assets/categoryBG.jpg';
import custImage from '../../assets/shirtBack.jpg';
import Loader from "react-js-loader";

function Home() {
    const [photos, setPhotos] = useState([]);
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchData = async () => {
            try {
                const [categoryRes, productsRes] = await Promise.all([
                    axios.get("https://sportsblendserver.netlify.app/.netlify/functions/api/displayCategory"),
                    axios.get("https://sportsblendserver.netlify.app/.netlify/functions/api/displayAllProducts")
                ]);
  
                setPhotos(categoryRes.data);
                setProducts(productsRes.data);
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchData();
    }, []);

    const shuffledProducts = [...products].sort(() => Math.random() - 0.5);
    const randomThreeProducts = shuffledProducts.slice(0, 3); 

    const [colorChange, setColorchange] = useState("");

    useEffect(() => {
        const changeNavbarColor = () => {
            if (window.scrollY >= 10) {
                setColorchange("rgb(70, 70, 70)");
            } else {
                setColorchange("");
            }
        };

        window.addEventListener('scroll', changeNavbarColor);

        return () => {
            window.removeEventListener('scroll', changeNavbarColor);
        };
    }, []);

    const handleProductClick = () => {
        navigate('/browseproducts');
    };

    return (
        <div className='mpBG'>
            <Navbar bgcolor={colorChange} />
            <div className="background-container" style={{ background: `url(${categoryBG})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }}>
                <div className={styles.homeRoot}>
                    <h1 className={styles.xHero} style={{ fontSize: '3.5rem' }}>Customize your own Shirt!</h1>
                    <div className={styles.xcardMainDiv}>
                        <div className={styles.xcardSuperDiv}>
                            <div onClick={() => navigate('/productPage/65380ddac794fcf8d4778bd5')} className={styles.xcard} style={{ backgroundImage: `url(${custImage})` }}>
                                <div className={styles.xplayerName}>
                                    <h1>Your Name</h1>
                                </div>
                                <div className={styles.xplayerNum}>
                                    <h1 style={{ userSelect: 'none' }}>10</h1>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles.secDiv}>
                <h1 className={styles.Hero}>Browse Products</h1>
                <div className={styles.cardsContainer}>
                    {randomThreeProducts.map(({ name, photo, _id }) => (
                        <div key={_id}>
                            <Link to={`/productCustomize/${_id}`} className='card-link'>
                                <Card
                                    name={name}
                                    cardImage={photo && photo.length > 0 ? `https://sportsblendserver.netlify.app/.netlify/images?url=/images/${photo[0]}` : ''}
                                />
                            </Link>
                        </div>
                    ))}

                </div>
                <p>See more <b onClick={handleProductClick}>products</b></p>
            </div>
            <div className={styles.secDiv}>
                <h4 className={styles.sportTitle}>Categories</h4>
                <h1 className={styles.Hero}>Choose a Category</h1>
                <div className={styles.cardsContainer}>
                    {loading ? (
                        <Loader type="spinner-default" bgColor={'white'} size={60} />
                    ) : (
                        photos.map(({ name, photo, _id }) => (
                            <div key={_id}>
                                <Link to={`/productPage/${_id}`} className='card-link'>
                                    <Card
                                        name={name}
                                        cardImage={`https://sportsblendserver.netlify.app/.netlify/images?url=/images/${photo}`}
                                    />
                                </Link>
                            </div>
                        ))
                    )}
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default Home;
